import React, { useEffect, useState } from "react";

import MintModel from "../MintModel/MintModel";
import Header from "../Header/Header";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import Web3 from "web3";
import {
  Mint_Contract_Abi,
  Mint_Contract_Address,
} from "../../utilies/constant";

import "./Counter.css"
import CountUp from 'react-countup'
export default function Counter() {
   const [modalShow, setModalShow] = React.useState(false);
    const { chain } = useNetwork();
    const { chains, switchNetwork } = useSwitchNetwork();
    const { address } = useAccount();
    const { open } = useWeb3Modal();
  
      const [getBNB_value, setgetBNB_value] = useState("");
      const [mintPrice, setMintPrice] = useState(0);
      const [Price, setPrice] = useState(0);
    
      const [totalsupply, settotalsupply] = useState(0);
    
      const webSupply = new Web3("https://brockrpc.io");
      const [spinner, setspinner] = useState(false);
  const contractData = async () => {
      try {
        const contract = new webSupply.eth.Contract(
          Mint_Contract_Abi,
          Mint_Contract_Address
        );
        let tsupply =await contract.methods.totalSupply().call()
        let currentPrice= await contract.methods.checkPrice().call()
        setPrice(webSupply.utils.fromWei(currentPrice.toString()));
        settotalsupply(tsupply)
    
      } catch (error) {
        console.error("Error fetching contract data:", error);
      }
    };
  
      useEffect(() => {
        contractData();
      }, []);
  return (
    <div>
        <div className="bithu_total_counter_sect">
  <div className="container">
    <ul>
      <li>
        <h3>
          <span className="counter"><CountUp end={5555} duration={70} /></span>
        </h3>
        <h4>Total Items</h4>
      </li>
      <li>
        <h3>
          <span className="counter"><CountUp end={totalsupply} duration={70} /></span>
        </h3>
        <h4>Total Owners</h4>
      </li>
      <li>
        <h3>
          <span className="counter">300 BROCK</span>
        </h3>
        <h4>Floor Price (BROCK)</h4>
      </li>
      <li>
        <h3>
          <span className="counter"><CountUp end={Number(totalsupply)*Number(300)} duration={1} /> </span> BROCK
        </h3>
        <h4>Volume Traded (BROCK)</h4>
      </li>
    </ul>
  </div>
  <span className="square_shape1">
    <img src="assets/images/square_shape_2.png" alt="" />
  </span>
  <span className="square_shape2">
    <img src="assets/images/square_shape_1.png" alt="" />
  </span>
  <span className="square_shape3">
    <img src="assets/images/square_shape_1.png" alt="" />
  </span>
  <span className="square_shape4">
    <img src="assets/images/square_shape_2.png" alt="" />
  </span>
</div>

    </div>
  )
}
